import {getInitialReturnToOrigin, reviewAutoAssign, reviewEditedRoute, reviewPlannedLegs} from './auto-assign';
import {assignmentPlanForLegs} from '../../../common/flight-leg/assignment-plan';
import {createRouteSaveSession, routeFingerprint as fingerprintFlight} from './route-edit';
import FlightPassengerGuidance from './passenger-guidance';
import FlightDetailsForm from './details-form';
import {
    Alert,
    Button,
    Card,
    Col,
    Drawer,
    Dropdown,
    Icon,
    Layout,
    Menu,
    message,
    Modal,
    Popconfirm,
    Row,
    Spin,
    Tabs,
    Tooltip,
    Typography
} from 'antd';
import {
    buildLocNameMapFromPaxCgoLists,
    computeLegWeightsAndCounts,
    removeEmptyReturnLeg,
    makeRoundTrip,
    getFlightLegManagerFromFlightQuery
} from 'common/flight-leg/util';
import FlightManualScheduleLegPax from 'components/flights/scheduling/FlightManualScheduleLegPax';
import FlightManualScheduleLegs from 'components/flights/scheduling/FlightManualScheduleLegs';
import gql from 'graphql-tag';
import moment from 'moment';
import React, {useContext, useMemo, useRef, useState} from 'react';
import {useApolloClient, useQuery} from 'react-apollo';
import {useHistory, useParams} from 'react-router-dom';
import {castArray, momentOrNull, safeGet} from '../../../common/util';
import LoadingContent from '../../LoadingContent';
import NotAuthorized from '../../NotAuthorized';
import MainHeader, {MainHeaderProps} from '../../scheduling/MainHeader';
import MainLayout from '../../scheduling/MainLayout';
import useManifestPrintout from '../../scheduling/Printout/useManifestPrintout';
import withCognitoUser from '../../WithCognitoUser';
import WithOrgData from '../../WithOrgData';
import './UnifiedFlightEditor.less';
import FlightScheduleLegPax from 'components/flights/scheduling/FlightScheduleLegPax';
import FlightScheduleLegs from 'components/flights/scheduling/FlightScheduleLegs';
import {OrgDataContext} from "../../../context/orgData";
import {useMutation} from "@apollo/react-hooks";
import {FlightLeg} from "../../../schema";
import {useMultiSelect} from "../../../hooks/useMultiSelect";
import {createScheduledEntityColumns} from "components/flights/scheduling/columns";
import ETable from "../../enchanced-antd-table";
import {renderGroupNameMenuItems} from "components/flights/scheduling/FlightScheduleUtils";
import {ScheduledFlightFragment} from "../../../Queries/Scheduling";
import ScheduledPaxCgoAdder from "components/flights/scheduling/scheduled-paxcgo-adder";
import pluralize from 'pluralize';
import useBreakpoints from "../../../hooks/useBreakpoints";
import {NotesForPilotEditor} from "components/flights/scheduling/notes-for-pilot/editor/notes-for-pilot-editor";
import {useNotesForPilotEditorApi} from "components/flights/scheduling/notes-for-pilot/editor";
import {union, uniqBy} from "lodash";
import {
    PartialFlight,
    PartialFlightLeg,
} from 'components/flights/scheduling/scheduled-paxcgo-adder/hook';
import {CgoNode, PaxNode, TransitType} from "../../../common/types/carriable";
import {arrayToMap, isTruey} from "../../../common/util-ts";
import useApolloClientHelper from "../../../hooks/useApolloClientHelper";
import useRouteEditorApi from "components/flights/scheduling/route-editor/hook";
import RouteEditor from "components/flights/scheduling/route-editor/route-editor";
import useUserGroups from "../../../hooks/useUserGroups";
import {useTalosFlightPrintout} from "components/flights/scheduling/printout/talos-printout";
import * as constants from 'common/constants';
import PaxNotifierDrawer, {usePaxNotifierDrawerState} from "../../editor/pax-notifier/drawer/drawer";
import CheckinPaxNotifier from "../../editor/pax-notifier/modes/check-in/checkin-pax-notifier";
import SafetyCardAlert from "../../scheduling/safety-card-alert";
import {
    FlightEditorEntityColumn,
    UnifiedFlightEditorProps,
    isFeatureAuthorized,
    isFeatureEnabled,
    isPermissionGranted
} from "./configuration";
import {toManifestPassenger, toManifestPrintoutTime} from './manifest-printout';

const { Content } = Layout;

export type UnifiedFlightEditorComponentProps = UnifiedFlightEditorProps;

type TEMP_TYPE_Flight = any;

type TEMP_TYPE_Flight_Query = {
    getFlight: TEMP_TYPE_Flight
};
type TEMP_TYPE_Entity = PaxNode | CgoNode

const FLIGHT = gql`
query Flight($_id: ID!){
    getFlight(_id: $_id){
        ...ScheduledFlightFragment
        weatherDelayTs
    }
}
${ScheduledFlightFragment}
`

const UPDATE_FLIGHT_LEGS = gql`
mutation UpdateFlightLegs($payload: FlightNodeInput!, $orgID: ID!){
    setFlight: editFlight(input: {action: UPDATE_ROUTE, patch: $payload}, orgID: $orgID){
        ...ScheduledFlightFragment
    }
}
${ScheduledFlightFragment}
`

const UPDATE_FLIGHT_PASSENGER = gql`
mutation UpdateFlightPassenger($flight: FlightNodeInput!, $orgID: ID!){
    setFlight: editFlight(input: {action: UPDATE_ASSIGNMENTS, patch: $flight}, orgID: $orgID){
        ...ScheduledFlightFragment
    }
}
${ScheduledFlightFragment}
`

const DELETE_FLIGHT = gql`
mutation DeleteFlight($_id: ID! $tpID: ID!){
    deleteFlight(_id: $_id tpID: $tpID){
        ...ScheduledFlightFragment
    }
}
${ScheduledFlightFragment}
`
const SCHEDULED_TO_EXPECTED = gql`
mutation ScheduledToExpected($flightID: String!){
    setScheduledToExpected(flightID: $flightID){
        ...ScheduledFlightFragment
    }
}
${ScheduledFlightFragment}
`

// Hook for Talos printout
function useTalosPrintout({ flight }: { flight: any }) {
    const { download, loading } = useTalosFlightPrintout({ flight });
    return {
        onClick: download,
        loading,
        disabled: loading || !flight
    };
}

function isTalos(orgData){
    return constants.organization.isTalosCustomer(orgData?.customer?._id);
}

const GET_CUSTOMER_MANIFEST_PRINTOUT = gql`
    query GetCustomerManifestPrintout($id: ID!){
        getCustomer(_id: $id){
            _id
            name
            manifestPrintout {
                type
                layouts {
                    name
                    logo
                }
            }
        }
    }
`;

// Hook for customs/manifest printout
function useFlightPrintout({
    flight,
    orgData,
    cognitoUser,
    manifestType
}: {
    flight: any;
    orgData: any;
    cognitoUser: any;
    manifestType: 'Manifest' | 'Hess';
}) {
    const [ fetchPrintout, fetching ] = useManifestPrintout('FlightWithLegs', manifestType);

    const { data } = useQuery(GET_CUSTOMER_MANIFEST_PRINTOUT, {
        variables: { id: orgData?.customer?._id },
        skip: !orgData?.customer?._id
    });

    const manifestPrintouts = safeGet(['getCustomer', 'manifestPrintout'], data) || [];
    const flightManifest = manifestPrintouts.find((m) => m.type === 'Flight');
    const hessLayout = flightManifest && flightManifest.layouts && flightManifest.layouts.find((l) => l.name === 'Hess');
    const logoURL = hessLayout && hessLayout.logo;

    const onClick = React.useCallback(() => {
        if (!flight || !orgData || !cognitoUser){
            return;
        }

        const userAttr = cognitoUser.attributes || {};
        const legs = flight.legsArray || [];

        const estDepartureTimeObj = toManifestPrintoutTime(flight.estDepartureTime);

        const body = {
            issuedBy: `${userAttr.given_name || ''} ${userAttr.family_name || ''}`.trim(),
            orgName: orgData.customer && orgData.customer.name,
            logoURL: logoURL,
            desig: flight.desig,
            departure: flight.departureID && flight.departureID.name,
            aircraftNo: flight.aircraftID && flight.aircraftID.tailNum,
            scheduledFlightDate: flight.scheduledFlightDate,
            estDepartureTime: estDepartureTimeObj,
            legs: legs.map((leg) => {
                const legPax = (leg && leg.paxIDs) || [];
                const legCgo = (leg && leg.cgoIDs) || [];

                // Names, weights and routing belong to the passenger, not its optional person lookup.
                const passengers = legPax.filter(Boolean).map(toManifestPassenger);

                return {
                    departure: leg.departure,
                    destination: leg.destination,
                    passengers: passengers,
                    cargo: legCgo.map((cgo) => ({
                        _id: cgo._id,
                        name: cgo.name,
                        weight: cgo.weight,
                        chargeCode: cgo.chargeCode && cgo.chargeCode.toUpperCase(),
                        departure: cgo.departureID && cgo.departureID.name,
                        destination: cgo.destinationID && cgo.destinationID.name,
                        attentionTo: cgo.attentionTo,
                        deliveredBy: cgo.deliveredBy,
                        transitType: cgo.transitType,
                        approvedBy: cgo.approvedBy
                    }))
                };
            })
        };

        fetchPrintout(body, true, `${orgData.customer.name} Flight Manifest.xlsx`).catch((err) => {
            message
                .error('Failed to download printout', 3)
                .then(() => message.error(err?.message || 'Unknown error'), null);
        });
    }, [flight, orgData, cognitoUser, fetchPrintout, logoURL]);

    return {
        onClick,
        loading: fetching,
        disabled: fetching || !flight
    };
}

// Dropdown that executes printouts from menu items
const PrintoutDropdown_Internal: React.FC<{
    flight: any;
    orgData?: any;
    cognitoUser?: any;
    disabled?: boolean;
    includeManifest?: boolean;
}> = ({ flight, orgData, cognitoUser, disabled, includeManifest = false }) => {
    const manifest = useFlightPrintout({ flight, orgData, cognitoUser, manifestType: 'Manifest' });
    const customs = useFlightPrintout({ flight, orgData, cognitoUser, manifestType: 'Hess' });
    const talos = useTalosPrintout({ flight });

    return (
        <Dropdown
            overlay={
                <Menu>
                    {includeManifest ? (
                        <Menu.Item onClick={manifest.onClick} disabled={disabled || manifest.disabled}>
                            Flight Manifest
                        </Menu.Item>
                    ) : null}
                    <Menu.Item onClick={customs.onClick} disabled={disabled || customs.disabled}>
                        Customs Printout
                    </Menu.Item>
                    {isTalos(orgData) ? (
                        <Menu.Item onClick={talos.onClick} disabled={disabled || talos.disabled}>
                            Talos Printout
                        </Menu.Item>
                    ) : null}
                </Menu>
            }
        >
            <Button disabled={disabled}>Download <Icon type="down" /></Button>
        </Dropdown>
    );
};

export const PrintoutDropdown = WithOrgData(withCognitoUser(PrintoutDropdown_Internal));


const INIT_STATE = {
    selectedLeg: 0,
    selectedLegs: [],
    manualAssign: "auto",
    passengerDrawerOpen: false,
    routeEditorOpen: false,
    passengerModalOpen: false,
    deleting: false,
    manualLegs: []
}

interface RouterParams {
    id: string
}

interface ReviewChangesProps {
    entitiesToRemove: TEMP_TYPE_Entity[],
    entitiesToModify: TEMP_TYPE_Entity[],
    entitiesToAdd: TEMP_TYPE_Entity[],
    manualLegs?: FlightLeg[],
    showNotesForPilot?: boolean,
    columns?: FlightEditorEntityColumn[]
}

const ReviewChanges: React.FC<ReviewChangesProps> = (props) => {
    const orgData = useContext(OrgDataContext);

    function renderEntityList(title: string, icon: React.ReactNode, rowColor: string, entities: TEMP_TYPE_Entity[]){
        if (!entities || !entities.length) return null;

        const columns = createScheduledEntityColumns(null, {
            reviewMode: true,
            showSafetyCard: constants.organization.isTalosCustomer(orgData?.customerID),
            showNotesForPilot: props.showNotesForPilot,
            columns: props.columns
        });

        columns.unshift({
            title: '',
            key: 'icon',
            render: () => icon
        })

        return <div>
            <h4>{title}</h4>
            <ETable
                className='mc-table mc-scheduling-leg-pax'
                dataSource={entities}
                columns={columns}
                rowKey={(record: TEMP_TYPE_Entity) => record._id}
                onRow={() => ({ style: { backgroundColor: rowColor} })}
                size="small"
                pagination={false}
            />
        </div>
    }

    function renderTitle(action: string, items: any[]){
        let title = `${action} ${items.length} items`;
        if (props.manualLegs){
            title += ' from legs: ' + props.manualLegs.map(
                function RenderLegText(leg){
                    return `${leg.departure} → ${leg.destination}`;
                }
            ).join(', ')
        }
        return title;
    }

    return <>
        {renderEntityList(renderTitle('Removing', props.entitiesToRemove), <Icon type="close" style={{ color: '#ff0000' }} />, '#ff00003d', props.entitiesToRemove)}
        {renderEntityList(renderTitle('Modifying', props.entitiesToModify), <Icon type="edit" style={{ color: '#0084ff' }} />, '#0084ff3d', props.entitiesToModify)}
        {renderEntityList(renderTitle('Adding', props.entitiesToAdd), <Icon type="plus" style={{ color: '#00ff00' }} />, '#00ff003d', props.entitiesToAdd)}
    </>
}

const UnifiedFlightEditor_Internal: React.FC<UnifiedFlightEditorComponentProps> = (props) => {
    const [ state, _setState ] = useState(INIT_STATE);
    const [makingRoundTrip, setMakingRoundTrip] = useState(false);
    const orgData = useContext(OrgDataContext);
    const history = useHistory();
    const routerParams = useParams<RouterParams>();
    const flightID = props.flightId || routerParams.id;
    const configuration = props.configuration;
    const client = useApolloClient();
    const [ userGroups ] = useUserGroups();
    const { resolveEntityIdsByType, getScheduledPaxByIds, getScheduledCgoByIds } = useApolloClientHelper();

    const paxNotifierDrawerState = usePaxNotifierDrawerState();

    const [makeFlightExpectedMutation, makeFlightExpectedResult] = useMutation(SCHEDULED_TO_EXPECTED);

    const drawerBreakpoints = useBreakpoints({
        widthOffset: 24
    });

    const entityMultiSelect = useMultiSelect<TEMP_TYPE_Entity>({
        primaryKey: '_id'
    })

    const editPermissionGranted = isPermissionGranted(configuration.editPermission, userGroups);

    // ---------------------------------------------------------------------------------
    // Queries and mutations
    // ---------------------------------------------------------------------------------
    const { data, loading, error, refetch } = useQuery<TEMP_TYPE_Flight_Query>(FLIGHT,
        {
            variables: {
                _id: flightID
            },
            fetchPolicy: "cache-and-network",
            pollInterval: 60_000 // One minute
        }
    )
    const hasEditPerm = editPermissionGranted
        && (configuration.canEditFlight ? configuration.canEditFlight(data?.getFlight) : true);

    const allEntities = useMemo(() =>
        [...castArray(data?.getFlight?.paxIDList), ...castArray(data?.getFlight?.cgoIDList)]
    , [data]);

    const notesForPilotApi = useNotesForPilotEditorApi({
        entities: allEntities
    });

    const [editingFlightDetails, setEditingFlightDetails] = useState(false);
    const routeEditorApi = useRouteEditorApi();
    const [routeSnapshot, setRouteSnapshot] = useState('');
    const saveRouteSession = useRef(createRouteSaveSession());
    const routeSubmission = useRef(false);
    const assignmentReviewActive = useRef(false);
    const [reviewingAssignments, setReviewingAssignments] = useState(false);
    async function reviewLegs(legs: FlightLeg[], always = false, labels?: Map<string, string>) {
        if (assignmentReviewActive.current) return;
        assignmentReviewActive.current = true;
        setReviewingAssignments(true);
        try { return await reviewPlannedLegs(legs, always, labels); }
        finally { assignmentReviewActive.current = false; setReviewingAssignments(false); }
    }

    const [reviewingRoute, setReviewingRoute] = useState(false);
    const routeFingerprint = fingerprintFlight(data?.getFlight);
    const currentRouteFingerprint = useRef(routeFingerprint);
    currentRouteFingerprint.current = routeFingerprint;
    const routeIsStale = state.routeEditorOpen && routeSnapshot !== routeFingerprint;
    const assignmentLabels = new Map<string, string>();
    (data?.getFlight?.paxIDList || []).forEach(pax => assignmentLabels.set(`pax:${pax._id}`, `${pax.lastName || ''}, ${pax.firstName || ''}`));
    (data?.getFlight?.cgoIDList || []).forEach(cargo => assignmentLabels.set(`cgo:${cargo._id}`, cargo.name));


    function setState(newState: Partial<typeof INIT_STATE>){
        _setState(currState => ({...currState, ...newState}))
    }

    /** Reviews automatic assignments in the dialog, or returns a manual proposal for the caller to save. */
    const buildAssignment = async (
        paxnodes: PaxNode[],
        cgonodes: CgoNode[],
        save: (flight: PartialFlight) => Promise<void>
    ): Promise<PartialFlight | void> => {
                if (!data?.getFlight) return;
                const flight = data.getFlight;
                paxnodes.forEach(pax => assignmentLabels.set(`pax:${pax._id}`, `${pax.lastName || ''}, ${pax.firstName || ''}`));
                cgonodes.forEach(cargo => assignmentLabels.set(`cgo:${cargo._id}`, cargo.name));
                const snapshot = currentRouteFingerprint.current;
                if (state.manualAssign === 'manual'){
                    // Manual assign

                    const legs = Object.values<PartialFlightLeg>(JSON.parse(flight.legs));

                    const paxnodeIds = paxnodes.map(p => p._id);
                    const cgonodeIds = cgonodes.map(c => c._id);

                    for (let selectedLeg of state.selectedLegs) {
                        const leg = legs[selectedLeg];
                        if (!leg) continue;

                        leg.paxIDs = union(leg.paxIDs, paxnodeIds);
                        leg.cgoIDs = union(leg.cgoIDs, cgonodeIds);
                    }

                    const manager = getFlightLegManagerFromFlightQuery({...flight, legs,
                        paxIDList: uniqBy([...(flight.paxIDList || []), ...paxnodes], '_id'),
                        cgoIDList: uniqBy([...(flight.cgoIDList || []), ...cgonodes], '_id')});
                    const reviewed = await reviewLegs(manager.buildFlightLegs({disableCreateMissingLegs: true}), false, assignmentLabels);
                    if (!reviewed || snapshot !== currentRouteFingerprint.current) return;
                    return {legs: reviewed,
                        paxIDList: Array.from(new Set(reviewed.flatMap(leg => leg.paxIDs))),
                        cgoIDList: Array.from(new Set(reviewed.flatMap(leg => leg.cgoIDs)))};
                }
                else
                {
                    // Auto assign
                    const allPaxNodes = uniqBy([
                        ...(flight.paxIDList || []),
                        ...(paxnodes || [])
                    ], '_id');
                    const allCgoNodes = uniqBy([
                        ...(flight.cgoIDList || []),
                        ...(cgonodes || [])
                    ], '_id');
                    const locationNames = buildLocNameMapFromPaxCgoLists(allPaxNodes, allCgoNodes);

                    const createAutoAssignManager = (
                        initialLegs?: FlightLeg[],
                        returnToOrigin?: boolean
                    ) => {
                        return getFlightLegManagerFromFlightQuery(
                            {
                                ...flight,
                                legs: initialLegs === undefined ? flight.legs : initialLegs,
                                paxIDList: allPaxNodes,
                                cgoIDList: allCgoNodes
                            },
                            locationNames,
                            undefined,
                            typeof returnToOrigin === 'boolean' ? {returnToOrigin} : undefined
                        );
                    };

                    const buildAutoAssignResult = (
                        flManager,
                        createMissingLegs: boolean
                    ) => {

                        var departureID = flManager.getOrigin();
                        if (!departureID){
                            message.error("Cannot add a group with no departure on a flight.")
                            return
                        }

                        const buildFromManager = (manager, allowMissingLegs: boolean) => {
                            let paxIds = [];
                            let cgoIds = [];

                            const legs = manager.buildFlightLegs({
                                disableCreateMissingLegs: !allowMissingLegs,
                                getInfo: (data) => {
                                    paxIds = data.paxIds;
                                    cgoIds = data.cgoIds;
                                }
                            });

                            return {
                                legs,
                                paxIDList: paxIds,
                                cgoIDList: cgoIds
                            };
                        };

                        return buildFromManager(flManager, createMissingLegs);
                    }

                    const computeAutoAssign = (createMissingLegs: boolean) => (
                        buildAutoAssignResult(createAutoAssignManager(), createMissingLegs)
                    );

                    const setAutoAssignReturnToOrigin = (
                        route,
                        returnToOrigin: boolean,
                        createMissingLegs: boolean
                    ) => buildAutoAssignResult(
                        createAutoAssignManager(route.legs, returnToOrigin),
                        createMissingLegs
                    );

                    const origLegs = Object.values<PartialFlightLeg>(JSON.parse(flight.legs));

                    // Legs with createMissingLegs enabled
                    const legsWithNew = computeAutoAssign(true);

                    // Legs with createMissingLegs disabled
                    const legsWithoutNew = computeAutoAssign(false);

                    const initialReturnToOrigin = getInitialReturnToOrigin(origLegs);
                    const initialReviewRoute = setAutoAssignReturnToOrigin(legsWithNew, initialReturnToOrigin, true);
                    const plan = assignmentPlanForLegs(initialReviewRoute.legs);
                    const preservedPlan = assignmentPlanForLegs(legsWithoutNew.legs);
                    if (!plan) throw new Error('Could not prepare route assignments.');

                    const names = new Map(locationNames);
                    [initialReviewRoute.legs, legsWithoutNew.legs].flat().forEach((leg) => {
                        names.set(leg.departureID, leg.departure || leg.departureID);
                        names.set(leg.destinationID, leg.destination || leg.destinationID);
                    });
                    const hasIncompatibleJourneys = preservedPlan?.rows.some(
                        (row) => !row.candidates.length && !row.ranges.length
                    );
                    setReviewingAssignments(true);

                    try {
                        await reviewAutoAssign({
                            initialPlan: plan,
                            currentRoutePlan:
                                origLegs.length && hasIncompatibleJourneys ? preservedPlan : undefined,
                            returnToOrigin: initialReturnToOrigin,
                            names,
                            labels: assignmentLabels,
                            isCurrent: () => snapshot === currentRouteFingerprint.current,
                            save,
                        });
                    } finally {
                        setReviewingAssignments(false);
                    }

                }
    };

    const paxCgoAdderState = ScheduledPaxCgoAdder.useState(
        configuration.AssignmentDrawer ? false : state.passengerDrawerOpen,
        flightID,
        data?.getFlight?.scheduledFlightDate,
        {
            onFlightUpdated: () => setState({ passengerDrawerOpen: false }),
            override: {
                addEntitiesToFlight: buildAssignment
            }
        }
    );

    const [updateFlightMutation, updateFlightMutationResult] = useMutation(UPDATE_FLIGHT_PASSENGER);
    const [updateFlightLegsMutation, updateFlightLegsResult] = useMutation(UPDATE_FLIGHT_LEGS);

    /** Saves reviewed live-flight assignments and refreshes the editor only after persistence succeeds. */
    async function assignEntitiesFromExtension(paxnodes: PaxNode[], cgonodes: CgoNode[]) {
        if (!data?.getFlight) return;

        let saved = false;
        const persist = async (partialFlight: PartialFlight) => {
            const legs = await Promise.all(
                partialFlight.legs.map(async (leg) => {
                    const paxList = await getScheduledPaxByIds(leg.paxIDs);
                    const cgoList = await getScheduledCgoByIds(leg.cgoIDs);
                    return {
                        ...leg,
                        ...computeLegWeightsAndCounts(paxList, cgoList),
                    };
                })
            );

            const flight = data.getFlight;
            await updateFlightMutation({
                variables: {
                    flight: {
                        _id: flight._id,
                        paxIDList: partialFlight.paxIDList,
                        cgoIDList: partialFlight.cgoIDList,
                        customerID: props.orgData.customer._id,
                        tpID: props.orgData.transporter._id,
                        legs: JSON.stringify(Object.assign({}, legs)),
                    },
                    orgID: props.orgData.getActiveOrgID(),
                },
            });

            saved = true;
        };
        const partialFlight = await buildAssignment(paxnodes, cgonodes, persist);
        if (partialFlight) await persist(partialFlight);
        if (!saved) return;

        await refetch();
        closePassengerDrawer();
        message.success('Successfully assigned PAX/CGO');
    }

    // Details autosaves serialize themselves while inputs remain responsive.
    // Other route/assignment mutations must still exclude form edits.
    const otherEditsBusy =
        reviewingRoute || reviewingAssignments || makingRoundTrip ||
        state.deleting ||
        updateFlightMutationResult.loading ||
        updateFlightLegsResult.loading ||
        makeFlightExpectedResult.loading;
    const isBusy = editingFlightDetails || otherEditsBusy;

    // ---------------------------------------------------------------------------------

    function openPassengerDrawer() {
        setState({passengerDrawerOpen: true})
    }

    function closePassengerDrawer() {
        setState({passengerDrawerOpen: false})
    }

    const routeEditor = {
        open: () => {
            const manager = getFlightLegManagerFromFlightQuery(data.getFlight);
            routeEditorApi.dispatch({type: 'INIT', payload: {
                flightPath: getLocationsFromLegs(manager.initialLegs),
                departureID: data.getFlight.departureID?._id
            }});
            setRouteSnapshot(routeFingerprint);
            setState({routeEditorOpen: true})
        },
        close: () => {
            setState({routeEditorOpen: false});
            routeEditorApi.route.reset();
        }
    }

    function deleteFlight() {
        const {_id} = data.getFlight;
        setState({deleting: true})
        client.mutate({
            mutation: DELETE_FLIGHT,
            variables: {
                _id,
                tpID: orgData.transporter._id
            }
        })
            .then(() => {
                history.push('/app/scheduling/flight')
            })
            .catch(error => {
                console.error(error);
                setState({ deleting: false });
                message.error(`Failed to delete flight: ${error.message}`);
            })
    }

    async function derefEntity(type: 'pax' | 'cgo'){

    }

    async function removeEntitiesRecalLegs(entities: TEMP_TYPE_Entity[]){
        return new Promise(async (resolve, reject) => {
            const entityIdMap = arrayToMap<string, TEMP_TYPE_Entity>(
                [...entities, ],
                "_id"
            );
            const { customer, transporter } = props.orgData;
            const { _id: flightid, legs: jsonLegs } = data.getFlight;

            const legs = Object.values<FlightLeg>(JSON.parse(jsonLegs));

            const entityIds = entities.map(e => e._id);

            const partialFlight = {
                paxIDList: [] as string[],
                cgoIDList: [] as string[],
                legs: [] as FlightLeg[]
            }

            if (state.manualAssign === 'manual'){
                partialFlight.legs = legs.map((leg, idx) => {
                    if (!state.selectedLegs.includes(idx)){
                        return leg;
                    }

                    const paxIds = leg.paxIDs
                        .filter((pId) => !entityIds.includes(pId));
                    const cgoIds = leg.cgoIDs
                        .filter((cId) => !entityIds.includes(cId));

                    return {
                        ...leg,
                        paxIDs: paxIds,
                        cgoIDs: cgoIds
                    }
                })
                partialFlight.paxIDList = partialFlight.legs
                    .reduce((paxIds: string[], leg) => {
                        return union(paxIds, leg.paxIDs);
                    }, []);

                partialFlight.cgoIDList = partialFlight.legs
                    .reduce((cgoIds: string[], leg) => {
                        return union(cgoIds, leg.cgoIDs);
                    }, [])
            }
            else {
                let flManager = getFlightLegManagerFromFlightQuery(data.getFlight);

                for (let entity of entities) {
                    flManager.removePassenger(entity._id);
                    flManager.removeCgo(entity._id);
                }

                partialFlight.legs = flManager.buildFlightLegs({disableCreateMissingLegs: true});
                partialFlight.paxIDList = flManager.getPaxIDList();
                partialFlight.cgoIDList = flManager.getCgoIDList();
            }

            const reviewedRemoval = await reviewLegs(partialFlight.legs, false, assignmentLabels);
            if (!reviewedRemoval) { resolve(false); return; }
            partialFlight.legs = reviewedRemoval;
            partialFlight.paxIDList = Array.from(new Set(reviewedRemoval.flatMap(leg => leg.paxIDs)));
            partialFlight.cgoIDList = Array.from(new Set(reviewedRemoval.flatMap(leg => leg.cgoIDs)));
            partialFlight.legs = await Promise.all(
                partialFlight.legs.map(async (leg) => {

                    const paxList = await getScheduledPaxByIds(leg.paxIDs);
                    const cgoList = await getScheduledCgoByIds(leg.cgoIDs);

                    return {
                        ...leg,
                        ...computeLegWeightsAndCounts(
                            paxList,
                            cgoList
                        )
                    }
                })
            )

            const flightPayload = {
                _id: flightid,
                paxIDList: partialFlight.paxIDList,
                cgoIDList: partialFlight.cgoIDList,
                customerID: customer._id,
                tpID: transporter._id,
                legs: JSON.stringify(Object.assign({}, partialFlight.legs))
            }

            Modal.confirm({
                title: 'Review Changes',
                maskClosable: false,
                content: <ReviewChanges
                    entitiesToRemove={entities}
                    entitiesToModify={[]}
                    entitiesToAdd={[]}
                    showNotesForPilot={isFeatureEnabled(configuration, 'notesForPilot', userGroups)}
                    columns={configuration.entityColumns}
                    manualLegs={
                        (function GetManualLegs(){
                            if (state.manualAssign !== 'manual') return [];

                            return state.selectedLegs

                                // Map leg index to leg
                                .map((index) => partialFlight.legs[index])

                                // Remove null legs
                                .filter(l => l)
                        })()
                    }
                />,
                width: 'fit-content',
                onOk: () => {
                    return updateFlightMutation({
                        variables: {
                            flight: flightPayload,
                            orgID: props.orgData.getActiveOrgID()
                        }
                    })
                        .then(() => {
                            message.success('Successfully removed from flight');
                            refetch();
                            paxCgoAdderState.api.data.refetch();
                            resolve(true);
                        })
                        .catch(error => {
                            console.error(error);
                            message.error('Failed to remove from flight.');
                            reject(error);
                        })
                }
            })
        })
    }

    async function onLegsReorder(dragIndex: number, hoverIndex: number) {
        if (!hasEditPerm || isBusy) return;
        const { orgData } = props;
        const { _id: flightid, legs, paxIDList = [], cgoIDList = [] } = data.getFlight;
        if (!legs) return null;

        const flManager = getFlightLegManagerFromFlightQuery(data.getFlight);
        const result = flManager.reorderAndBuildFlightLegs(dragIndex, hoverIndex, {
            createMissingLegs: true
        });
        if ('error' in result) {
            message.warn(result.error);
            return null;
        }

        const snapshot = currentRouteFingerprint.current;
        const newLegs = await reviewLegs(result.legs, false, assignmentLabels);
        if (!newLegs) return;
        if (snapshot !== currentRouteFingerprint.current) {
            message.warning('The flight changed. Review its current route before reordering.');
            return;
        }
        let newLegsJson = JSON.stringify( Object.assign({}, newLegs) )

        const paxById = new Map(paxIDList.map(pax => [pax._id, pax]));
        const cgoById = new Map(cgoIDList.map(cgo => [cgo._id, cgo]));
        let newLegsArray = newLegs.map(leg => {
            return {
                ...leg,
                paxIDs: leg.paxIDs.map(id => paxById.get(id)).filter(isTruey),
                cgoIDs: leg.cgoIDs.map(id => cgoById.get(id)).filter(isTruey)
            }
        })

        updateFlightLegsMutation({
            variables: {
                payload: {
                    _id: flightid,
                    legs: newLegsJson,
                    tpID: orgData.transporter._id,
                    customerID: orgData.customer._id
                },
                orgID: orgData.getActiveOrgID()
            },
            optimisticResponse: {
                __typename: 'Mutation',
                setFlight: {
                    __typename: 'FlightNode',
                    _id: flightid,
                    legs: newLegsJson,
                    legsArray: newLegsArray
                }
            }
        })
            .then(() => message.success('Flight legs successfully updated'))
            .catch(error => {
                console.error(error);
                message.error('Failed to update flight legs')
            })
    }

    function getSelectedLegsFromLegs(legs: FlightLeg[]) {
        const arr: FlightLeg[] = [];
        [...state.selectedLegs].sort((left, right) => left - right).forEach(legIdx => {
            if (legs.length <= legIdx) return;
            arr.push(legs[legIdx])
        })

        return arr;
    }

    function getLocationsFromLegs(legs: FlightLeg[]) {
        if (!legs) return [];
        var arr = [];

        legs.forEach(leg => {
            arr.push(leg.departureID);
        })

        if(legs.length > 0){
            arr.push(legs[legs.length-1].destinationID);
        }


        return arr
    }

    async function makeFlightRoundTrip() {
        if (!hasEditPerm || isBusy) return;
        const snapshot = currentRouteFingerprint.current;
        try {
            const currentLegs = getFlightLegManagerFromFlightQuery(data.getFlight).initialLegs;
            const proposed = makeRoundTrip(currentLegs);
            if (proposed === currentLegs) return;
            setMakingRoundTrip(true);
            const manager = getFlightLegManagerFromFlightQuery({...data.getFlight, legs: proposed});
            const legs = await reviewLegs(manager.buildFlightLegs({disableCreateMissingLegs: true}), false, assignmentLabels);
            if (!legs) return;
            if (snapshot !== currentRouteFingerprint.current) throw new Error('The flight changed. Review its route again.');
            await updateFlightLegsMutation({
                variables: {
                    payload: {
                        _id: data.getFlight._id,
                        legs: JSON.stringify(Object.assign({}, legs)),
                        tpID: orgData.transporter._id,
                        customerID: orgData.customer._id
                    },
                    orgID: orgData.getActiveOrgID()
                }
            });
            await refetch();
            message.success('Return leg added. The flight is now a round trip.');
        } catch (err) {
            console.error(err);
            message.error('Failed to make the flight a round trip.');
        } finally {
            setMakingRoundTrip(false);
        }
    }

    async function removeEmptyReturn(legIndex: number) {
        if (!hasEditPerm || isBusy) return;
        const snapshot = currentRouteFingerprint.current;
        try {
            const currentLegs = getFlightLegManagerFromFlightQuery(data.getFlight).initialLegs;
            const proposed = removeEmptyReturnLeg(currentLegs, legIndex);
            const manager = proposed.length ? getFlightLegManagerFromFlightQuery({...data.getFlight, legs: proposed}) : null;
            const legs = manager ? await reviewLegs(manager.buildFlightLegs({disableCreateMissingLegs: true}), false, assignmentLabels) : [];
            if (!legs) return;
            if (snapshot !== currentRouteFingerprint.current) throw new Error('The flight changed. Review its route again.');
            await updateFlightLegsMutation({
                variables: {
                    payload: {
                        _id: data.getFlight._id,
                        legs: JSON.stringify(Object.assign({}, legs)),
                        tpID: orgData.transporter._id,
                        customerID: orgData.customer._id
                    },
                    orgID: orgData.getActiveOrgID()
                }
            });
            setState({
                selectedLeg: Math.max(0, Math.min(state.selectedLeg, legs.length - 1)),
                selectedLegs: state.selectedLegs.filter(index => index < legs.length)
            });
            message.success(legs.length
                ? 'Empty return leg removed. The flight is now one-way.'
                : 'Empty origin-to-origin leg removed. Create a route or use Auto Assign to continue.');
            await refetch();
        } catch (err) {
            console.error(err);
            message.error('Failed to remove the empty return leg.');
        }
    }

    async function removeRedundantLeg(legIndex: number){
        if (!hasEditPerm || isBusy) return;
        const snapshot = currentRouteFingerprint.current;
        let flManager = getFlightLegManagerFromFlightQuery(data.getFlight);

        if (!flManager.removeLegIfRedundant(legIndex)){
            return;
        }

        let legs = await reviewLegs(flManager.buildFlightLegs({disableCreateMissingLegs: true}), false, assignmentLabels);
        if (!legs || snapshot !== currentRouteFingerprint.current) return;

        let flightid = data.getFlight._id;

        try{
            var res = await updateFlightLegsMutation({
                variables: {
                    payload: {
                        _id: flightid,
                        legs: JSON.stringify( Object.assign({}, legs) ),
                        tpID: props.orgData.transporter._id,
                        customerID: props.orgData.customer._id
                    },
                    orgID: props.orgData.getActiveOrgID()
                },
                optimisticResponse: {
                    __typename: 'Mutation',
                    setFlight: {
                        __typename: 'FlightNode',
                        _id: flightid
                    }
                }
            })
        }
        catch(err){
            console.error(err);
            message.error("Failed to remove redundant leg.");
            return;
        }
        message.success('Successfully removed redundant leg.');
        refetch();
        return res;
    }

    async function handleModifyRoute(){
        if (routeSubmission.current || routeIsStale || !hasEditPerm) return;
        routeSubmission.current = true;
        setReviewingRoute(true);
        try {
            const saved = await saveRouteSession.current({
                flight: data.getFlight,
                initialVisits: routeEditorApi.state.initPath,
                visits: routeEditorApi.route.visits(),
                tenant: {
                    tpID: orgData.transporter._id,
                    customerID: orgData.customer._id,
                    orgID: orgData.getActiveOrgID(),
                },
                resolveLocations: (ids) => resolveEntityIdsByType(ids, 'Location'),
                confirmDepartureChange: async (departureID) => {
                    const locations = await resolveEntityIdsByType([departureID], 'Location');
                    const departure = locations.find(
                        (location) => location._id === departureID
                    );
                    if (!departure)
                        throw new Error('The new departure location could not be loaded.');

                    return new Promise<boolean>((resolve) => {
                        Modal.confirm({
                            title: 'Change flight departure?',
                            content: `The flight departure will change from ${
                                data.getFlight.departureID?.name ||
                                data.getFlight.departureID?._id
                            } to ${
                                departure.name
                            }. Passengers and cargo using the current departure will also use the new location. Continue to review the route and assignments?`,
                            okText: 'Continue to review',
                            cancelText: 'Back to editing',
                            onOk: () => resolve(true),
                            onCancel: () => resolve(false),
                        });
                    });
                },
                review: (legs, save) =>
                    reviewEditedRoute({
                        legs,
                        labels: assignmentLabels,
                        isCurrent: () => currentRouteFingerprint.current === routeSnapshot,
                        save,
                    }),
                isCurrent: () => currentRouteFingerprint.current === routeSnapshot,
                mutate: (variables) => updateFlightLegsMutation({variables}),
            });
            if (!saved) return;
            message.success('Flight legs successfully updated');
            routeEditor.close();
            await refetch();
            paxCgoAdderState.api.data.refetch();
        } catch (err) {
            message.error(err.message || 'Failed to update flight legs. Your draft is preserved.');
        } finally {
            routeSubmission.current = false;
            setReviewingRoute(false);
        }
    }

    function renderPaxNotifier(){

        if (!data || !data.getFlight) return null;

        const { paxIDList } = data.getFlight;
        if (!paxIDList || paxIDList.length === 0) return null;

        const outboundPax = paxIDList.filter((pax) => pax.transitType === TransitType.OUTBOUND);
        const scheduledFlightDate = momentOrNull(data.getFlight.scheduledFlightDate);

        if (!scheduledFlightDate) return null;

        const estDepartureTime = data.getFlight.estDepartureTime
            ? moment(data.getFlight.estDepartureTime, 'HH:mm')
            : null;

        return (
            <PaxNotifierDrawer {...paxNotifierDrawerState}>
                <CheckinPaxNotifier
                    offsetMinutesOptions={[-15, -30, -45, -60]}
                    requestedCheckInTime={estDepartureTime}
                    paxData={outboundPax}
                    scheduledFlightDate={scheduledFlightDate}
                    refetchAfterSave={() => {
                        return refetch().then(result => {
                            return result.data?.getFlight.paxIDList || [];
                        })
                    }}
                />
            </PaxNotifierDrawer>
        )
    }

    function renderContent() {
        const {orgData} = props;

        if (error) return <Alert type="error" message="Failed to load flight" description={error.message} showIcon/>

        if (loading && !data) return <LoadingContent/>
        if (!data || !data.getFlight) return <h2>No data returned</h2>
        if (data.getFlight.tpID._id !== orgData.transporter._id) {
            return <h2>Transportation providers do not match</h2>
        }
        const legs: FlightLeg[] = (data.getFlight.legs && Object.values(JSON.parse(data.getFlight.legs))) || []
        const routeActionLabel = legs.length ? 'Modify Route' : 'Create Route';
        const selectedLeg = legs?.[state.selectedLeg];

        let flManager = getFlightLegManagerFromFlightQuery(data.getFlight);

        const selectionUI = (
            <Row type="flex" style={{position: 'absolute', right: 0, top: 0, zIndex: 2, alignItems: 'center'}}>
                {entityMultiSelect.selectedItems.length > 0 ?
                    <span>
                            {entityMultiSelect.selectedItems.length} selected
                            <Button
                                style={{marginInline: 6}}
                                onClick={() => entityMultiSelect.clearAll()}
                                size="small"
                            >Clear</Button>
                            </span>
                    : null}
                <Dropdown
                    overlay={<Menu>
                        <Menu.Item key="all" onClick={() => entityMultiSelect.setSelectedItems(allEntities)}>Select
                            All</Menu.Item>
                        <Menu.Item key="all" onClick={() => entityMultiSelect.clearAll()}>Select
                            None</Menu.Item>
                        <Menu.SubMenu title="By Group">
                            {renderGroupNameMenuItems(entityMultiSelect, allEntities)}
                        </Menu.SubMenu>
                    </Menu>}
                >
                    <Button style={{marginRight: 6}}>Select... <Icon type="check-square"/></Button>
                </Dropdown>
                <Button
                    type="danger"
                    disabled={!entityMultiSelect?.selectedItems.length || isBusy}
                    onClick={() => entityMultiSelect.selectedItems.length > 0 && removeEntitiesRecalLegs(entityMultiSelect.selectedItems)
                        .then(() => entityMultiSelect.clearAll())}
                >
                    Remove Selected
                    <Icon type="delete"/>
                </Button>
            </Row>
        )

        const routeAction = (
            <Tooltip title={routeActionLabel}>
                <span>
                    <Button
                        className="mc-btn-green flight-schedule-legs__header-action"
                        icon="edit"
                        aria-label={routeActionLabel}
                        onClick={routeEditor.open}
                        disabled={!hasEditPerm || isBusy}
                    >
                        <span className="flight-schedule-legs__action-label">{routeActionLabel}</span>
                    </Button>
                </span>
            </Tooltip>
        );

        const autoAssignTab = (
            <Row type="flex" gutter={24} className="scheduling-flight-edit-assignment">
                <Col className="scheduling-flight-edit-legs-col-left">
                    <FlightScheduleLegs
                        flight={data.getFlight}
                        selectedLeg={state.selectedLeg}
                        data={legs}
                        selectedEntities={entityMultiSelect.selectedItems}
                        onAddLegs={openPassengerDrawer}
                        onMakeRoundTrip={hasEditPerm ? makeFlightRoundTrip : undefined}
                        makingRoundTrip={makingRoundTrip}
                        onLegChange={(index: number) => setState({selectedLeg: index})}
                        onRemoveEmptyReturnLeg={hasEditPerm
                            ? (_leg: FlightLeg, index: number) => removeEmptyReturn(index)
                            : undefined}
                        checkLegIsRedundant={(_leg: FlightLeg, index: number) => flManager.isLegRedundant(index)}
                        onRemoveRedundantLeg={hasEditPerm
                            ? (_leg: FlightLeg, index: number) => removeRedundantLeg(index)
                            : undefined}
                        onReorder={isBusy ? undefined : onLegsReorder}
                        extra={[
                            hasEditPerm ? (
                                <Tooltip title="Auto-Assign PAX/CGO">
                                    <span>
                                        <Button
                                            className="flight-schedule-legs__header-action"
                                            type="primary"
                                            icon="user-add"
                                            aria-label="Auto-Assign PAX/CGO"
                                            onClick={openPassengerDrawer}
                                            disabled={isBusy}
                                        >
                                            <span className="flight-schedule-legs__action-label">Auto Assign</span>
                                        </Button>
                                    </span>
                                </Tooltip>
                            ) : (
                                <Tooltip title="You do not have permission to access this feature.">
                                    <span>
                                        <Button
                                            className="flight-schedule-legs__header-action"
                                            type="primary"
                                            icon="user-add"
                                            aria-label="Auto-Assign PAX/CGO"
                                            disabled={true}
                                        >
                                            <span className="flight-schedule-legs__action-label">Auto Assign</span>
                                        </Button>
                                    </span>
                                </Tooltip>
                            ),
                            routeAction
                        ]}
                        disabled={!hasEditPerm || isBusy}
                    />
                </Col>
                <Col className="scheduling-flight-edit-pax-col-right">
                    <Spin indicator={<Icon type="loading"/>}
                          spinning={updateFlightMutationResult.loading}>
                        <FlightScheduleLegPax
                            flight={data.getFlight}
                            selectedLegIndex={state.selectedLeg}
                            departureName={selectedLeg?.departure}
                            destinationName={selectedLeg?.destination}
                            multiSelect={entityMultiSelect}
                            events={{
                                onRemoveRedundantLeg: selectedLeg && flManager.isLegRedundant(state.selectedLeg) ?
                                    () => removeRedundantLeg(state.selectedLeg) : undefined
                            }}
                            disabled={isBusy}
                            readOnly={!hasEditPerm}
                            showNotesForPilot={isFeatureEnabled(configuration, 'notesForPilot', userGroups)}
                            columns={configuration.entityColumns}
                        />
                    </Spin>
                </Col>
            </Row>
        )

        const manualAssignTab = (
            <Row type="flex" gutter={24} className="scheduling-flight-edit-assignment">
                <Col className="scheduling-flight-edit-legs-col-left">
                    <FlightManualScheduleLegs
                        flight={data.getFlight}
                        selectedLegs={state.selectedLegs}
                        data={legs}
                        selectedEntities={entityMultiSelect.selectedItems}
                        onAddLegs={openPassengerDrawer}
                        onMakeRoundTrip={hasEditPerm ? makeFlightRoundTrip : undefined}
                        makingRoundTrip={makingRoundTrip}
                        disabled={isBusy}
                        onRemoveEmptyReturnLeg={hasEditPerm
                            ? (_leg: FlightLeg, index: number) => removeEmptyReturn(index)
                            : undefined}
                        checkLegIsRedundant={(_leg: FlightLeg, index: number) => flManager.isLegRedundant(index)}
                        onRemoveRedundantLeg={hasEditPerm
                            ? (_leg: FlightLeg, index: number) => removeRedundantLeg(index)
                            : undefined}
                        onLegChange={(index: number) => {
                            const selectedLegs = state.selectedLegs.includes(index)
                                ? state.selectedLegs.filter((selectedIndex: number) => selectedIndex !== index)
                                : [...state.selectedLegs, index];
                            setState({selectedLegs});
                        }}
                        extra={[
                            !state.selectedLegs.length ? (
                                <Tooltip title="Auto-Assign PAX/CGO">
                                    <span>
                                        <Button
                                            className="flight-schedule-legs__header-action"
                                            type="primary"
                                            icon="user-add"
                                            aria-label="Auto-Assign PAX/CGO"
                                            onClick={openPassengerDrawer}
                                            disabled={!!state.selectedLegs.length || isBusy}
                                        >
                                            <span className="flight-schedule-legs__action-label">Auto Assign</span>
                                        </Button>
                                    </span>
                                </Tooltip>
                            ) : null,
                            state.selectedLegs.length ? (
                                <Tooltip title="Manual Assign PAX/CGO">
                                    <span>
                                        <Button
                                            className="flight-schedule-legs__header-action"
                                            type="primary"
                                            icon="user-add"
                                            aria-label="Manual Assign PAX/CGO"
                                            onClick={openPassengerDrawer}
                                            disabled={!state.selectedLegs.length || isBusy}
                                        >
                                            <span className="flight-schedule-legs__action-label">Manual Assign</span>
                                        </Button>
                                    </span>
                                </Tooltip>
                            ) : null,
                            routeAction
                        ].filter(isTruey)}
                    />
                </Col>
                <Col className="scheduling-flight-edit-pax-col-right">
                    <FlightManualScheduleLegPax
                        selectedLegs={getSelectedLegsFromLegs(legs)}
                        multiSelect={entityMultiSelect}
                        isLegRedundant={(leg: FlightLeg) => flManager.isLegRedundant(leg.order)}
                        onRemoveRedundantLeg={(leg: FlightLeg) => removeRedundantLeg(leg.order)}
                        readOnly={!hasEditPerm}
                        disabled={isBusy}
                    />
                </Col>
            </Row>
        )

        const tabs = (
            <Tabs
                type="card"
                defaultActiveKey="auto"
                onChange={tab => setState({manualAssign: tab})}
                className="scheduling-flight-edit-legs-tabs"
            >
                <Tabs.TabPane key="auto" tab={(
                    <Tooltip mouseEnterDelay={1} title="Automatically assign passengers and cargo to flight legs, creating or extending the route as needed.">
                        <span>Auto Assign</span>
                    </Tooltip>
                )}>
                    <Card>
                        <div style={{margin: '-12px'}}>
                            {autoAssignTab}
                        </div>
                    </Card>
                </Tabs.TabPane>
                <Tabs.TabPane key="manual" tab={(
                    <Tooltip mouseEnterDelay={1} title="Choose flight legs and manually assign passengers or cargo to those legs.">
                        <span>Manual Assign</span>
                    </Tooltip>
                )}>
                    <Card>
                        <div style={{margin: '-12px'}}>
                            {manualAssignTab}
                        </div>
                    </Card>
                </Tabs.TabPane>
            </Tabs>
        )

        return (
            <FlightPassengerGuidance
                flight={data.getFlight}
                canEdit={hasEditPerm}
                editPermissionGranted={editPermissionGranted}
            >
                <FlightDetailsForm
                    key={flightID}
                    onBusyChange={setEditingFlightDetails}
                    disabled={!hasEditPerm || otherEditsBusy}
                    showWeatherDelay={isFeatureEnabled(configuration, 'weatherDelay', userGroups)}
                    weatherDelayDisabled={!isFeatureAuthorized(configuration, 'weatherDelay', userGroups)}
                    fields={configuration.formFields}
                    data={data.getFlight}
                    onSubmitted={() => refetch()}
                />
                <SafetyCardAlert
                    passengers={data.getFlight?.paxIDList}
                    customerID={props.orgData?.customer?._id}
                    style={{marginBottom: 12}}
                />
                <div style={{position: 'relative'}}>
                    {hasEditPerm ? selectionUI : null}
                    {hasEditPerm ? tabs : <Card bodyStyle={{ padding: 12 }}>{autoAssignTab}</Card>}
                </div>
                {isFeatureEnabled(configuration, 'notesForPilot', userGroups) ? (
                    notesForPilotApi.getNotes().size > 0 ? (
                        <>
                            <h3 style={{marginTop: 16}}>
                                Notes For Pilot
                                <span style={{ marginLeft: 6 }}>
                                    <Typography.Text
                                        type="secondary"
                                    >({notesForPilotApi.getNotes().size} Notes)</Typography.Text>
                                </span>
                            </h3>
                            <NotesForPilotEditor
                                {...notesForPilotApi.getComponentProps()}
                                readOnly
                            />
                        </>
                    ) : (
                        <>
                            <h3 style={{marginTop: 16}}>
                                Notes For Pilot
                            </h3>
                            <Typography.Paragraph type="secondary">No data</Typography.Paragraph>
                        </>
                    )
                ) : null}
                {configuration.AssignmentDrawer ? (
                    <configuration.AssignmentDrawer
                        flight={data.getFlight}
                        loading={isBusy}
                        refetch={refetch}
                        orgData={props.orgData}
                        visible={state.passengerDrawerOpen}
                        assignmentMode={state.manualAssign as 'auto' | 'manual'}
                        selectedLegs={state.selectedLegs}
                        onClose={closePassengerDrawer}
                        onAssign={assignEntitiesFromExtension}
                    />
                ) : (
                <Drawer
                    headerStyle={{
                        padding: 12
                    }}
                    bodyStyle={{
                        padding: 12
                    }}
                    title={
                        <>
                            <div
                                style={{
                                    marginBottom: 12,
                                    display: drawerBreakpoints.max('large') ? 'block' : 'none'
                                }}
                            >
                                <h3 style={{margin: 0, fontSize: '1rem'}}>Select PAX/CGO to add to
                                    <span style={{marginLeft: 4}}
                                          className="mc-text-highlight">{data?.getFlight?.desig}</span>
                                </h3>
                            </div>
                            <Row
                                type="flex"
                                align="middle"
                                gutter={10}
                            >
                                <Col
                                    style={{
                                        flex: 1,
                                        display: drawerBreakpoints.min('large') ? 'block' : 'none'
                                    }}
                                >
                                    <h3 style={{margin: 0, fontSize: '1rem'}}>Select PAX/CGO to add to
                                        <span style={{marginLeft: 4}}
                                              className="mc-text-highlight">{data?.getFlight?.desig}</span>
                                    </h3>
                                </Col>
                                <Col>
                                    {paxCgoAdderState.render.searchTypeSelect()}
                                </Col>
                                <Col>
                                    {paxCgoAdderState.render.searchInput()}
                                </Col>
                                <Col style={{marginRight: '2rem'}}>
                                    {paxCgoAdderState.render.addButton({ disabled: isBusy })}
                                </Col>
                            </Row>
                        </>
                    }
                    visible={state.passengerDrawerOpen}
                    closable
                    width={drawerBreakpoints.max('large') ? '100%' : 1000}
                    onClose={closePassengerDrawer}
                    className="ant-drawer-flex"
                >
                    <Typography.Paragraph type="secondary">
                        View legs and PAX/CGO by clicking on the rows
                    </Typography.Paragraph>
                    <Row type="flex" style={{alignItems: 'baseline'}}>
                        <Col style={{flex: 1,}}>
                            <strong>
                                        <span
                                            style={{
                                                marginRight: 4
                                            }}
                                        >{paxCgoAdderState.api.data.groups.get().length}</span>
                                {pluralize('Group', paxCgoAdderState.api.data.groups.get().length)}
                            </strong>
                        </Col>
                        <Col>
                            <Button
                                type="link"
                                onClick={paxCgoAdderState.api.action.collapse.toggleAll}
                                style={{
                                    paddingLeft: 0,
                                    paddingRight: 0
                                }}
                            >
                                {paxCgoAdderState.api.action.collapse.isAllExpanded() ? (
                                        "Collapse All"
                                    ) :
                                    (
                                        "Expand All"
                                    )}
                            </Button>
                        </Col>
                    </Row>
                    {paxCgoAdderState.render.filtersAppliedAlert()}
                    {paxCgoAdderState.render.errorAlert()}
                    <ScheduledPaxCgoAdder
                        {...paxCgoAdderState.componentProps}
                    />
                    {paxCgoAdderState.render.paxModal()}
                </Drawer>
                )}
                <Drawer
                    visible={state.routeEditorOpen}
                    destroyOnClose
                    width="50rem"
                    onClose={() => { if (!reviewingRoute && !isBusy) routeEditor.close(); }}
                    title={
                        <Row style={{ alignItems: 'center' }} type="flex" gutter={6}>
                            <Col style={{ flex: 1 }}>
                                <h3 style={{ margin: 0 }}>{routeActionLabel}</h3>
                            </Col>
                            {routeEditorApi.state.changed ? (
                                <Col>
                                    <Button
                                        type="link"
                                        disabled={reviewingRoute || isBusy}
                                        onClick={routeEditorApi.route.reset}
                                    >Reset</Button>
                                </Col>
                            ) : null}
                            <Col style={{ marginRight: 36 }}>
                                <Button
                                    type="primary"
                                    disabled={!routeEditorApi.state.changed || isBusy || reviewingRoute || routeIsStale || !routeEditorApi.route.get().length}
                                    onClick={handleModifyRoute}
                                    loading={updateFlightLegsResult.loading || reviewingRoute}
                                >Review route</Button>
                            </Col>
                        </Row>
                    }
                >
                    <RouteEditor
                        disabled={reviewingRoute || updateFlightLegsResult.loading}
                        stale={routeIsStale}
                        onReload={routeEditor.open}
                        overrideState={{
                            state: routeEditorApi.state,
                            dispatch: routeEditorApi.dispatch
                        }}
                    />
                    <p style={{ margin: '6px 0 0 0' }}>
                        <Typography.Text type="warning">
                            Changing the first stop also changes the flight departure.
                        </Typography.Text>
                    </p>
                </Drawer>
            </FlightPassengerGuidance>
        )
    }

    const checkIfToday = (date) => {
        return momentOrNull(date)?.isSameOrBefore(moment().startOf('day'));
    }

    function confirmMakeExpected(){
        return new Promise<boolean>((resolve, reject) => {
            Modal.confirm({
                title: 'Are you sure?',
                content: <div>
                    <p>This will change the status of this flight and all of its passengers/cargo to <strong>EXPECTED.</strong></p>
                    <p>This operation is final. Expected flights will be placed on the live grid.</p>
                </div>,
                onOk: () => resolve(true),
                onCancel: () => reject()
            })
        })
    }

    const paxWithDeletedPersonnel = data?.getFlight.paxIDList.filter(pax => !pax.personID);

    function confirmWithDeletedPersonnel(){
        return new Promise<boolean>((resolve, reject) => {
            if (!paxWithDeletedPersonnel?.length){
                resolve(true);
            }
            Modal.warning({
                title: 'Deleted Personnel Detected',
                content: <div>
                    <p><strong>
                        <Typography.Text type="warning">WARNING</Typography.Text>
                    </strong></p>
                    <p>Some passengers on this flight are associated with personnel records that have been deleted.</p>
                    <p>The following passengers/cargo will be deleted and not be moved to expected status.</p>
                    <p>You will need to be manually re-added to the flight after it is made expected:</p>
                    <ul>
                        {paxWithDeletedPersonnel?.map(pax => {
                            return <li key={pax._id}>{pax.lastName}, {pax.firstName}</li>
                        })}
                    </ul>
                    <p>Are you sure you want to proceed?</p>
                </div>,
                onOk: () => resolve(true),
                onCancel: () => reject()
            })
        })
    }

    function makeFlightExpected(){
        const flightID = data.getFlight._id
        makeFlightExpectedMutation({
            variables: { flightID }
        })
            .then(() => {
                history.push('/app/flights')
            })
            .catch(error => {
                console.error(error);
                message.error(`Failed to make flight active or passengers expected: ${error.message}`);
            })
    }

    function renderHeader(){
        const isToday = checkIfToday(data?.getFlight?.scheduledFlightDate);
        const hasLegs = data?.getFlight.legsArray?.length > 0;
        const hasPaxOrCgo = data?.getFlight.paxIDList?.length > 0 || data?.getFlight.cgoIDList?.length > 0;
        const showDelete = isFeatureEnabled(configuration, 'delete', userGroups);
        const canDelete = isFeatureAuthorized(configuration, 'delete', userGroups) && hasEditPerm;
        const showPrintout = isFeatureEnabled(configuration, 'printout', userGroups);
        const showNotify = isFeatureEnabled(configuration, 'notify', userGroups);
        const showMakeExpected = isFeatureEnabled(configuration, 'makeExpected', userGroups);
        const canMakeExpected = isToday && hasLegs && hasPaxOrCgo && hasEditPerm
            && isFeatureAuthorized(configuration, 'makeExpected', userGroups);
        const HeaderActions = configuration.HeaderActions;
        const PrintoutAction = configuration.PrintoutAction;

        let makeExpectedTooltipMsg = "";

        if (!hasLegs){
            makeExpectedTooltipMsg = "You must add legs first.";
        }
        else if (!hasPaxOrCgo){
            makeExpectedTooltipMsg = "You must add pax or cargo first.";
        }
        else if (!isToday){
            makeExpectedTooltipMsg = `You must wait until ${momentOrNull(data?.getFlight.scheduledFlightDate).format('MMMM Do, YYYY')} to make this flight expected.;`
        }

        const mainHeaderProps: MainHeaderProps = {
            routes: configuration.routes(data?.getFlight, loading) as any,
            actions: (
                <React.Fragment>
                    <Row type="flex" gutter={12}>
                        {showDelete ? <Col>
                            {canDelete ? (
                                <Popconfirm title="Are you sure you want to delete this flight?" okText="Delete" onConfirm={deleteFlight} placement="leftTop">
                                    <Button
                                        disabled={isBusy}
                                        loading={state.deleting}
                                        type="danger"
                                    >Delete Flight</Button>
                                </Popconfirm>
                            ) : (
                                <Tooltip title="You do not have permission to access this feature.">
                                    <Button disabled={true} type="danger">Delete Flight</Button>
                                </Tooltip>
                            )}
                        </Col> : null}
                        {showPrintout ? <Col>
                            {PrintoutAction && data?.getFlight ? (
                                <PrintoutAction
                                    flight={data.getFlight}
                                    loading={isBusy}
                                    refetch={refetch}
                                    orgData={props.orgData}
                                />
                            ) : (
                                <PrintoutDropdown
                                    flight={data && data.getFlight}
                                    disabled={loading || Boolean(error) || !data || !data.getFlight}
                                />
                            )}
                        </Col> : null}
                        {showNotify ? <Col>
                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item
                                            onClick={paxNotifierDrawerState.open}
                                        >
                                            Notify PAX...
                                        </Menu.Item>
                                    </Menu>
                                }
                            >
                                <Button>Tools <Icon type="down" /></Button>
                            </Dropdown>
                        </Col> : null}
                        {showMakeExpected ? <Col>
                            <Tooltip title={makeExpectedTooltipMsg} placement="bottomLeft">
                                <Button
                                    disabled={!canMakeExpected || isBusy}
                                    loading={makeFlightExpectedResult.loading}
                                    onClick={async () => {
                                        try {
                                            await confirmMakeExpected();
                                            await confirmWithDeletedPersonnel();
                                        }
                                        catch (err){
                                            console.warn('Confirmation modal closed. Not making flight expected.');
                                            return;
                                        }
                                        makeFlightExpected();
                                    }}
                                    type="primary"
                                >
                                    Make Flight Expected <Icon type="right" />
                                </Button>
                            </Tooltip>
                        </Col> : null}
                        {HeaderActions && data?.getFlight ? <Col>
                            <HeaderActions
                                flight={data.getFlight}
                                loading={isBusy}
                                refetch={refetch}
                                orgData={props.orgData}
                            />
                        </Col> : null}
                    </Row>
                </React.Fragment>
            )
        }

        return <MainHeader {...mainHeaderProps} />
    }


    return (
        <MainLayout
            showSteps={isFeatureEnabled(configuration, 'schedulingSteps', userGroups)}
            className={configuration.layoutClassName}
            style={configuration.layoutStyle ? configuration.layoutStyle(props.style) : props.style}
        >
            {renderHeader()}
            <Content style={{ overflow: 'auto', padding: '1rem'}}>
                {renderContent()}
            </Content>
            {isFeatureEnabled(configuration, 'notify', userGroups) ? renderPaxNotifier() : null}
        </MainLayout>
    )
}

const NotAuth = () => (
    <MainLayout>
        <NotAuthorized />
    </MainLayout>
)

export const UnifiedFlightEditor = UnifiedFlightEditor_Internal;

export default UnifiedFlightEditor;
